// extracted by mini-css-extract-plugin
export default {"link":"rE-z","disabled":"sE-z"};